<app-history-filters (filtersChange)="applyFilters($event)" />

@if (loading()) {
  <app-ui-skeleton-grid [rows]="4" [rowHeight]="48" />
} @else if (events().length === 0) {
  <app-ui-empty-state
    compact
    title="Nenhum evento registrado"
    description="Eventos operacionais desta conversa aparecerão aqui conforme forem recebidos."
  />
} @else {
  <ol class="history-list">
    @for (event of events(); track event.id) {
      <app-event-renderer-host [event]="event" />
    }
  </ol>
}

@if (hasMore() && !loading()) {
  <button type="button" appButton variant="secondary" size="sm" class="history-load-more" (click)="loadMore()">Carregar mais</button>
}
